import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { PopupModule } from '@popup';
import { FormatModule } from 'src/app/pipes/format';
import { AmountModule } from 'src/app/pipes/amount';

const Modules = [
  MatIconModule,
  MatButtonModule,
  PopupModule,
  FormatModule,
  AmountModule,
];

@NgModule({
  imports: Modules,
  exports: Modules
})
export class RootSharedModule { }
